// extracted by mini-css-extract-plugin
export var addressAddress = "detailsAddress-module--address-address--b994c";
export var addressBody = "detailsAddress-module--address-body--8fc4f";
export var addressCarouselContainer = "detailsAddress-module--address-carousel-container--5993d";
export var addressContact = "detailsAddress-module--address-contact--86df6";
export var addressContent = "detailsAddress-module--address-content--1bd8a";
export var addressContentContainer = "detailsAddress-module--address-content-container--39a51";
export var addressFooter = "detailsAddress-module--address-footer--97c4f";
export var addressFooterBack = "detailsAddress-module--address-footer-back--a18a7";
export var addressMail = "detailsAddress-module--address-mail--ef56c";
export var addressPlace = "detailsAddress-module--address-place--85c19";
export var addressPlaceIcon = "detailsAddress-module--address-place-icon--2505f";
export var addressPlaceTitle = "detailsAddress-module--address-place-title--5a1c9";
export var addressTel = "detailsAddress-module--address-tel--fddc8";
export var addressTitle = "detailsAddress-module--address-title--29cc7";
export var editButton = "detailsAddress-module--edit-button--6536c";
export var pageAddress = "detailsAddress-module--page-address--f2bc0";
export var pageAddressAdditionalInfos = "detailsAddress-module--page-address-additional-infos--441fc";
export var separator = "detailsAddress-module--separator--664e7";